import { ExampleQueries } from '~modules/search/components/example-queries';
import { SearchInput } from '~modules/search/components/search-input';
import { SearchResults } from '~modules/search/components/search-results';
import { useSearchState } from '~modules/search/hooks/use-search-state';

import { BalancedMainHeading } from '~ui/app/headings/balanced-main-heading';
import { Typography } from '~ui/base/typography';

function SearchPage() {
  const { query, setQuery } = useSearchState();
  const hasQuery = query.length > 0;

  return (
    <div className="flex flex-col gap-y-12 pb-20 pt-12">
      <header className="flex flex-col gap-y-5">
        <BalancedMainHeading>
          Search the FAIR² dataset catalogue
        </BalancedMainHeading>
        <Typography
          variant="body-lg-extralight"
          as="p"
          className="max-w-2xl text-muted-foreground-dark"
        >
          Discover datasets published through SENSCIENCE — full-text search across
          titles, descriptions, authors and keywords. Results link out to the
          relevant FAIR² Data Portal.
        </Typography>
      </header>

      <section className="flex flex-col gap-y-3" aria-label="Dataset search">
        <SearchInput initialQuery={query} onSubmit={setQuery} />
        <ExampleQueries onSelect={setQuery} />
      </section>

      {hasQuery && <SearchResults query={query} />}
    </div>
  );
}

export { SearchPage };
